module.exports = __webpack_public_path__ + "img/example.894f4689.svg";